module.exports = __webpack_public_path__ + "static/media/horrormax-banner-american-scream-king.19bfbc00.jpg";